import { useId } from 'react';
export function InfrastructureArt({ kind }: { kind: 'storage' | 'cluster' }) {
  const id = useId().replace(/:/g, '');
  return (
    <svg
      className={`infrastructure-art ${kind}`}
      viewBox="0 0 480 240"
      role="img"
      aria-label={
        kind === 'storage'
          ? 'Documents organized beside a storage drive'
          : 'Connected computers sharing document processing'
      }
    >
      <defs>
        <pattern id={id} width="5" height="5" patternUnits="userSpaceOnUse">
          <path d="M0 5L5 0" stroke="currentColor" strokeWidth=".6" opacity=".3" />
        </pattern>
      </defs>
      <g fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round">
        {kind === 'storage' ? (
          <>
            <path d="M55 83L164 48L239 83V174L131 223L55 193Z" fill={`url(#${id})`} />
            {[0, 1, 2, 3, 4].map((i) => (
              <g key={i} transform={`translate(${i * 11} ${-i * 6})`}>
                <path
                  d="M78 94V63L103 53L120 60L167 44L182 52V132L118 158Z"
                  fill="var(--cp-surface-raised)"
                />
                <path d="M91 94L153 70M91 104L153 80M91 114L153 90" opacity=".4" />
              </g>
            ))}
            <path d="M55 111L131 142L239 101V174L131 223L55 193Z" fill="var(--cp-surface-raised)" />
            <path d="M55 111L131 142V223L55 193Z" fill={`url(#${id})`} />
            <path d="M156 165L204 144V168L156 189Z" />
            <path d="M280 63L352 36L418 67V193L347 225L280 195Z" fill="var(--cp-surface-raised)" />
            <path d="M280 63L347 95L418 67M347 95V225" />
            <path d="M280 63L347 95V225L280 195Z" fill={`url(#${id})`} />
            {[0, 1, 2].map((i) => (
              <g key={i} transform={`translate(0 ${i * 32})`}>
                <path d="M359 109L406 89V111L359 131Z" />
                <path d="M367 111L386 103" />
              </g>
            ))}
            <circle cx="369" cy="204" r="4" fill="var(--cp-learning-art-21)" stroke="none" />
          </>
        ) : (
          <>
            <path d="M110 158L241 203L371 158M241 203V124" strokeDasharray="3 4" />
            {[
              [40, 80],
              [170, 15],
              [300, 80],
            ].map(([x, y], i) => (
              <g key={i} transform={`translate(${x} ${y})`}>
                <path d="M0 12L88 0L125 19V99L37 115L0 95Z" fill={`url(#${id})`} />
                <path d="M8 18L87 8L116 23V89L38 104L8 86Z" fill="var(--cp-surface-raised)" />
                <path d="M50 112V131L28 143L81 151L104 139L78 128V107" />
                <path d="M35 34L81 27L95 37V73L49 84L35 76Z M81 27V42L95 37M45 47L72 42M45 56L84 49M45 65L84 58" />
                <path d="M15 93L36 101" stroke="var(--cp-learning-art-21)" strokeWidth="3" />
              </g>
            ))}
            <circle cx="241" cy="203" r="6" fill="var(--cp-learning-art-21)" stroke="none" />
          </>
        )}
        <path d="M28 229H449M55 233H423" strokeWidth=".6" opacity=".2" />
      </g>
    </svg>
  );
}
